module.exports = __webpack_public_path__ + "img/humburger-menu.svg";